import React from 'react';

const Tooltip = ({ children, message, i = 0 }) => {
	function showTooltip() {
		document.getElementById(`tooltip-${i}`).classList.remove('hidden');
	}
	function hideTooltip(flag) {
		document.getElementById(`tooltip-${i}`).classList.add('hidden');
	}

	return (
		<div
			onMouseOver={() => showTooltip()}
			onFocus={() => showTooltip()}
			onMouseOut={() => hideTooltip()}
			className="relative group flex"
		>
			{children}
			<div
				id={`tooltip-${i}`}
				role="tooltip"
				className="absolute z-20 top-7 left-4 scale-0 transition-all rounded p-2 text-xs group-hover:scale-100 whitespace-nowrap border px-3 left-0 bg-white hidden"
			>
				{message}
			</div>
		</div>
	);
};

/*(
	<div classNameName="group">
		<div className={`relative flex z-${15 - i}`}>
			{children}
			<span
				className={`absolute  z-${
					10 - i * 5
				} top-7 left-4 scale-0 transition-all rounded p-2 text-xs group-hover:scale-100 whitespace-nowrap border px-3 left-0 bg-white`}
			>
				{message}
			</span>
		</div>
	</div>
);*/

export default Tooltip;
